export default "__VITE_ASSET__CjvpCG5H__"